module.exports = {
    namespace: 'students',

    da: {
        register: {
            title: 'KLAR PÅ AT OPNÅ FAGLIG ERFARING <br> OG TJENE LIDT EKSTRA?',
            subtitle: 'Ansøg om at blive en Taskflex studerende!',

            steps: {
                information: 'Oplysninger',
                skills: 'Færdigheder',
                application: 'Ansøgning',
            },

            step2: {
                description: 'For at kunne komme igang med at løse opgaver skal du vælge nogle færdigheder du vil levere opgaver indenfor. Disse færdigheder bruges til at styre din pristagning samt for at kunder kan finde lige præcis dig',
                chooseSkills: 'Vælg mindst en eller flere færdigheder som du ønsker at løse opgaver indenfor. De kan ændres senere.',
                atLeastOneSkillError: 'Du skal vælge mindst én færdighed.',
                maximumThreeSkills: 'Du kan maksimalt vælge tre færdigheder.',
                maximumTwoSkillGroups: 'Du kan maksimalt vælge færdigheder fra to grupper.',
            },

            step3: {
                applicationPlaceholder: 'Beskriv dine erfaringer og hvorfor du kan skabe værdi ved at varetage faglige opgaver for små virksomheder. Du er velkommen til at uploade en fil som understøtter eller illustrerer dine evner.',
                attachReferencesOptional: 'Vedhæft CV og Referencer (valgfrit)',
                uploadAttachmentGuide: 'Du kan vedhæfte op til 3 filer, men kun .pdf-filer på mindre end 2MB.',
                selectFiles: 'Vælg filer',
                uploadSuccess: 'Filerne er nu uploadede og vil blive indsendt sammen med din ansøgning.',
                uploadError: 'Noget gik galt under uploadet. Prøv venligst igen.',
                maximumThreeFiles: 'Du kan maksimalt uploade tre filer.',
                termsOfUse: 'Betingelser for brug',
                iAgreeToTermsOfUse: 'Jeg er erklærer mig hermed enig i <a href="{url}" target="_blank">betingelserne for brug af Taskflex.dk</a>',
            },
        },


        contactModal: {
            steps: {
                projectInformation: 'Projektinformation',
                yourInformation: 'Dine Oplysninger',
                review: 'Gennemse og send',
            },
        },

        profile: {
            new: 'Ny',
            level: 'Niveau',
            ratingsScore: 'Vurdering',
            rating: 'Udtalelse',
            ratings: 'Udtalelser',
            about: 'Om',
            contact: 'Book',
            noUrlsAllowed: 'Teksten må ikke indeholde webadresser',
            skillTable: 'Færdigheder',
            editAbout: 'Rediger profiltekst',
            tabs: {
                profile: 'Profil',
                ratings: 'Anmeldelser',
            },
            short: 'Kort beskrivelse',
            shortPlaceholder: 'Kort beskrivelse om dig',
            references: {
                references: 'Referencer',
                createModalTitle: 'Tilføj Reference',
                editModalTitle: 'Rediger Reference',
                title: 'Titel',
                text: 'Beskrivelse',
                link: 'Link',
                image: 'Billede',
                addLinkToReference: 'Tilføj link til Referencen',
                imageRequirements: 'Du kan kun bruge .png og .jpg filer, mellem 600 gange 600, og 1500 gange 1500 pixels.',

                delete: {
                    modalTitle: 'Slet Reference',
                    warning: 'Er du sikker på at du vil slette denne reference? Dette kan ikke omgøres.',
                },
            },
        },

        card: {
            view: 'Profil',
        },

        forms: {
            application: 'Ansøgning',
            attachments: 'Vedhæftede referencer',
            terms: 'Betingelserne',
        },

        rating: {
            title: 'Titel',
            customer: 'Kundereference',
            body: 'Tekst',
            name: 'Navn',
            position: 'Stilling',
            score: 'Vurdering',
        },
    },

    en: {
        profile: {
            newUser: 'New at Taskflex',
            editAbout: 'Edit profile text',
        },

        forms: {
            application: 'Application',
            attachments: 'Attachments',
            terms: 'Terms',
        },
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/students/locales/index.js